module.exports = __webpack_public_path__ + "img/upload-image-icon.5ce16dc1.png";